import { wealthProApi } from "../../redux/api";
import _ from "lodash";

const hoAdminMasterAccountsApiEndpoints = wealthProApi.injectEndpoints({
    endpoints: builder => ({
        fetchIntroducersForMasterAccount: builder.query({
            query: ({ masterAccountId }) => `api/headofficeadmin/masteraccounts/${masterAccountId}/introducers`
        }),
        fetchApplicationsForMasterAccount: builder.query({
            query: ({masterAccountId, excludeExistingFees}) => `api/headofficeadmin/masteraccounts/${masterAccountId}/applications?excludeExistingFees=${excludeExistingFees}`
        }),
        searchHeadOfficeMasterAccounts: builder.query({
            query: ({ searchText, page = 1, limit = 100, sort = "AccountName" }) => `api/headofficeadmin/masteraccounts/search?searchTerm=${searchText}&page=${page}&limit=${limit}&sort=${sort}`
        }),
        searchMasterAccountApplications: builder.query({
            query: ({data, masterAccountId}) => ({
                url: `api/headofficeadmin/masteraccounts/${masterAccountId}`,
                method: 'POST',
                body: data
            }),
            transformResponse: (response, _, { data : {cacheKey} }) => {
                return { cacheKey, ...response };
            },
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return endpointName;
            },
            merge: (currentCache, newItems) => {
                if (_.isEqual(currentCache.cacheKey, newItems.cacheKey)) {
                    currentCache.pagination = newItems.pagination;
                    currentCache.results.push(...newItems.results);
                }
                else {
                    currentCache.cacheKey = newItems.cacheKey;
                    currentCache.pagination = newItems.pagination;
                    currentCache.results = [...newItems.results];
                }             
            }
        })
    })
});

export const {
    useFetchIntroducersForMasterAccountQuery,
    useFetchApplicationsForMasterAccountQuery,
    useLazySearchHeadOfficeMasterAccountsQuery,
    useLazySearchMasterAccountApplicationsQuery
} = hoAdminMasterAccountsApiEndpoints;